<template>
  <div>
    <vue-excel-xlsx :data="data" :columns="columns" :filename="'planilha_geral'" :sheetname="'sheetname'" class="btn btn-primary" v-if="controlerBtnSubmit">
      Resumo de SLA
    </vue-excel-xlsx>

    <button type="button" class="btn btn-primary" disabled v-else><i class='fa fa-refresh fa-spin'></i> Carregando planilha...</button>


  </div>
</template>

<script>
export default {
  data() {
    return {
      env: process.env,
      glosas: [],
      controlerBtnSubmit: false,
      itens: '',
      columns: [
        {
          label: 'Contrato',
          field: 'contrato'
        },
        {
          label: 'Tipo Contrato',
          field: 'tipo'
        },
        {
          label: 'UF',
          field: 'uf'
        },
        {
          label: 'Mes',
          field: 'mes'
        },
        {
          label: 'Ano',
          field: 'ano'
        },
        {
          label: 'Valor Multa',
          field: 'multa'
        },
        {
          label: 'Valor Glosa',
          field: 'valor'
        },
        {
          label: 'Valor Total',
          field: 'valorTotal'
        },
        {
          label: 'Enviado',
          field: 'enviado'
        }
      ],
      data: [],
      filtro: []
    }
  },
  mounted: function () {
    this.exportarPlanilhaGeral()
  },
  methods: {
    exportarPlanilhaGeral() {
      let vm = this
      // let sla = []
      this.controlerLoading = false
      // var meses = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
      // var $meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getPlanilhaGeralSla/1`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(function (response) {
          // sla = response.data
          vm.filtro = response.data
          vm.data = response.data
          vm.controlerBtnSubmit = true
          // for (let i in sla.multa) {
          //   let k = 0
          //   let enviado = null
          //   for (let j in sla.multa[i]) {
          //     enviado = 'Não'
          //     try {
          //       enviado = (sla.enviado[i][ $meses[k] ][0].envio_confirmado === 1) ? 'Sim' : 'Não'
          //     } catch (e) {
          //       enviado = 'Não'
          //     }
          //     vm.data.push(
          //       {
          //         contrato: (sla.contrato[i].numero_contrato).substring(0, 10),
          //         tipo: sla.contrato[i].tipo_imovel_servico,
          //         uf: sla.contrato[i].uf,
          //         mes: sla.valor_mensal_contrato[i][meses[k]].mes_referencia,
          //         ano: sla.valor_mensal_contrato[i][meses[k]].ano_referencia,
          //         multa: sla.multa[i][j].valor,
          //         enviado: enviado
          //       }
          //     )
          //     k++
          //   }
          // }
          // vm.getGlosaFiltroAnoContrato()
        })
    },
    priceFormat(value) {
      return 'R$ ' + value
    }// ,
    // getGlosaFiltroAnoContrato: function () {
    //   let vm = this
    //   this.controlerLoading = false
    //   this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/getGlosaFiltroEvidenciaContrato`, {
    //     contrato: vm.filtro.contrato,
    //     valor_mensal_contrato: vm.filtro.valor_mensal_contrato
    //   }, {
    //     headers: {
    //       'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
    //     }
    //   })
    //   .then(function (response) {
    //     vm.glosas = response.data
    //     for (let i in vm.glosas) {
    //       if (vm.glosas[i]) {
    //         vm.data[i].valor = parseFloat(vm.glosas[i].valor)
    //         vm.data[i].valorTotal = parseFloat(vm.data[i].multa) + parseFloat(vm.data[i].valor)
    //       } else {
    //         vm.data[i].valor = 0
    //         vm.data[i].valorTotal = parseFloat(vm.data[i].multa) + parseFloat(vm.data[i].valor)
    //       }
    //       if (vm.data[i].multa === null || vm.data[i].multa === undefined) {
    //         vm.data[i].multa = 0
    //       } else {
    //         vm.data[i].multa = vm.data[i].multa.toLocaleString('pt-br', {maximumFractionDigits: 2})
    //       }
    //       vm.data[i].valor = vm.data[i].valor.toLocaleString('pt-br', {maximumFractionDigits: 2})
    //       vm.data[i].valorTotal = vm.data[i].valorTotal.toLocaleString('pt-br', {maximumFractionDigits: 2})
    //     }
    //   })
    //   this.controlerBtnSubmit = true
    // }
  }
}
</script>

<style scoped>
button:hover {
  background-color: #6c757d;
}

/* button {
    background-color:#3c7fe4;
    color: white;
    margin: 1%;
    margin-right: 5px;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:5px;
    padding-top:5px;
    border-style: none;
    border-radius: 5px;
    width: 160px;
    height: 50px;
  } */
/* button {
  background-color:#3c7fe4;
  color: white;
  margin: 1%;
  padding-left:15px;
  padding-right:15px;
  padding-bottom:5px;
  padding-top:5px;
  border-style: none;
  border-radius: 5px;
} */
</style>



// WEBPACK FOOTER //
// ExportSla.vue?750ee466